import React from 'react';
import PropTypes from 'prop-types';
import {Link as RouterLink} from 'react-router-dom';
import {Button} from 'reactstrap';
import classNames from 'classnames'
import styles from './Button.module.scss'

const ButtonBase = (props) => {

    //console.log(props)

    const {to, href, type, children, className, disabled, small, ...rest} = props;

    if (href) {
        return <a href={href} className={classNames([styles.Button, type && styles[type], className, disabled && styles[disabled], small && styles.ButtonSmal])}
           disabled={disabled} {...rest}
        >
            {children}
        </a>
    }

    if (to) {
        return <RouterLink to={to}>
            <Button className={classNames([styles.Button, type && styles[type], className, disabled && styles[disabled], small && styles.ButtonSmal])}
                    disabled={disabled}>
                {children}
            </Button>
        </RouterLink>
    }

    return (
        <Button  className={classNames([styles.Button, type && styles[type], className, disabled && styles[disabled], small && styles.ButtonSmal])}
                disabled={disabled} {...rest}
                type={type}
        >
            {children}
        </Button>
    )
}

ButtonBase.propTypes = {
    disabled: PropTypes.bool,
    to: PropTypes.string,
    className: PropTypes.string,
};

ButtonBase.defaultProps = {
    disabled: false,
    className: '',
    to: null
};
export default React.memo(ButtonBase);
